export const QUERY_PARAM = {
  buildingPermit: 'building-permit',
  buildingPlanReview: 'building-plan-review',
  businessLicense: 'business-licence',
  developmentPermit: 'development-permit',
  environmentalResourcePermit: 'environmental-permit',
  accessibilityCompliance: 'accessibility-compliance',
  contactInfo: 'contact-info',
  electricalInspection: 'electrical-inspection',
  landUseRedesignation: 'land-use-redesignation',
  mechanicalPermit: 'mechanical-permit',
  municipalHearing: 'municipal-hearing',
  plumbingPermit: 'plumbing-permit',
  plat: 'plat',
  dashboardSelectedGroup: 'group',
  address: 'address',
  zoom: 'zoom',
  minPrice: 'cost_min',
  maxPrice: 'cost_max',
  search: 'search',
  clone: 'clone',
  page: 'page',
  coordinates: 'coordinates',
  center: 'center',
  landTitleChange: 'land-title-change',
  mapFilters: 'map-filters',
  city: 'city',
  email: 'email',
  collection: 'collection',
  lead: 'lead',
  invite_code: 'invite_code',
  regionCode: 'region-code',
  stateCode: 'state-code',
  isEditorInitialized: 'is-editor-initialized',
  documentId: 'document-id',
  documentType: 'document-type',
  isDocumentView: 'document-view',
  scoutAgentChatId: 'chat',
  importCompanies: 'import',
  filters: 'f',
};

export enum DOCUMENT_TYPE_VALUES {
  ENVIRONMENTAL_RESOURCE_PERMIT = 'environmental-permit',
  ACCESSIBILITY_COMPLIANCE = 'accessibility-compliance',
  BUILDING_PERMIT = 'building-permit',
  BUILDING_PLAN_REVIEW = 'building-plan-review',
  // NOTE: This is enum value is the British/Canadian spelling and what is in our database as an enumeration
  BUSINESS_LICENSE = 'business-licence',
  DEVELOPMENT_PERMIT = 'development-permit',
  ELECTRICAL_INSPECTION = 'electrical-inspection',
  LAND_TITLE_CHANGE = 'land-title-change',
  LAND_USE_REDESIGNATION = 'land-use-redesignation',
  MECHANICAL_PERMIT = 'mechanical-permit',
  MUNICIPAL_HEARING = 'municipal-hearing',
  PLAT = 'plat',
  PLUMBING_PERMIT = 'plumbing-permit',
}
